// Simon/Myers brand system (locked palette)
export const BRAND = {
  yellow: "#FFCE24",
  yellowHover: "#F2C31F",
  charcoal: "#2B2E34",
  charcoalLight: "#3A3E46",
  black: "#000000",
  gray: "#404040",
  gray2: "#848484",
  white: "#FFFFFF",
  surface: "#F6F6F6",
  surface2: "#E9E7E0",
  ground: "#E4E1D8",
  groundTile: "#D8D4CA",
  road: "#CFCBC0",
  bg: "#EFEEE9",
};

export const COLOR_PRESETS = [
  { label: "Charcoal", value: "#2B2E34" },
  { label: "Yellow", value: "#FFCE24" },
  { label: "White", value: "#FFFFFF" },
  { label: "Gray", value: "#848484" },
];

export const ACCENT_PRESETS = [
  { label: "Yellow", value: "#FFCE24" },
  { label: "Charcoal", value: "#2B2E34" },
];

export const SHAPE_OPTIONS = [
  { label: "Tower", value: "tower" },
  { label: "Block", value: "block" },
  { label: "HQ", value: "hq" },
  { label: "Beacon", value: "beacon" },
  { label: "Kiosk", value: "kiosk" },
];
